export const normalizeExternalLink = (link: string) =>
  link.includes('http') ? link : `//${link}`;
